export default "__VITE_ASSET__BUpO5wA9__"